module.exports = __webpack_public_path__ + "static/img/snake.4db786a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snake.png
// module id = /0iM
// module chunks = 0